const RETURN_PATH_KEY = 'returnPath';

export function isSafeInternalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
}

export function saveReturnPath(path: string): void {
  const trimmed = (path || '').trim();
  if (!trimmed || trimmed === '/login' || trimmed.startsWith('/login?')) {
    return;
  }
  if (!isSafeInternalPath(trimmed)) {
    return;
  }
  sessionStorage.setItem(RETURN_PATH_KEY, trimmed);
}

export function peekReturnPath(): string | null {
  const value = sessionStorage.getItem(RETURN_PATH_KEY);
  if (!value || !isSafeInternalPath(value)) {
    return null;
  }
  return value;
}

export function consumeReturnPath(): string | null {
  const value = peekReturnPath();
  sessionStorage.removeItem(RETURN_PATH_KEY);
  return value;
}

export function clearReturnPath(): void {
  sessionStorage.removeItem(RETURN_PATH_KEY);
}
